import React, { useRef, useEffect } from 'react';

function AnimaltHatterJogi2() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);
    const alakzatok = Array.from({length: 16}, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      meret: Math.random() * 60 + 20,
      vx: (Math.random() - 0.5) * 0.25, vy: (Math.random() - 0.5) * 0.25,
      szin: ['#1a73e8','#34a853','#9c27b0','#f9ab00','#00bcd4'][Math.floor(Math.random()*5)],
      alpha: Math.random() * 0.05 + 0.02,
    }));
    const rajzol = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      alakzatok.forEach(a => {
        a.x += a.vx; a.y += a.vy;
        if (a.x < -a.meret) a.x = canvas.width + a.meret;
        if (a.x > canvas.width + a.meret) a.x = -a.meret;
        if (a.y < -a.meret) a.y = canvas.height + a.meret;
        if (a.y > canvas.height + a.meret) a.y = -a.meret;
        ctx.beginPath(); ctx.arc(a.x, a.y, a.meret/2, 0, Math.PI*2);
        ctx.fillStyle = a.szin; ctx.globalAlpha = a.alpha; ctx.fill(); ctx.globalAlpha = 1;
      });
      animId = requestAnimationFrame(rajzol);
    };
    rajzol();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={canvasRef} style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0}}/>;
}

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
  .jogi-wrapper * { font-family: 'Nunito', sans-serif !important; }
  .jogi-wrapper h2 { font-size: 22px; font-weight: 900; color: #1a1a2e; margin: 2rem 0 0.75rem; }
  .jogi-wrapper p, .jogi-wrapper li { font-size: 15px; color: #444; line-height: 1.8; }
  .jogi-wrapper ul { padding-left: 1.25rem; margin: 0.5rem 0; }
  .jogi-wrapper li { margin-bottom: 0.4rem; }
  .jogi-wrapper strong { color: #1a1a2e; }
`;

function Aszf() {
  return (
    <div className="jogi-wrapper" style={{minHeight: '100vh', background: 'linear-gradient(135deg, #f8f9ff 0%, #f3e5f5 50%, #f5fff8 100%)', padding: '3rem 2rem', position: 'relative', overflow: 'hidden'}}>
      <style>{globalStyles}</style>
      <AnimaltHatterJogi2/>
      <div style={{position: 'relative', zIndex: 1, maxWidth: '760px', margin: '0 auto'}}>

        <div style={{textAlign: 'center', marginBottom: '2.5rem'}}>
          <div style={{display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'rgba(255,255,255,0.9)', border: '2px solid #9c27b0', borderRadius: '50px', padding: '10px 24px', fontSize: '15px', fontWeight: '800', color: '#9c27b0', marginBottom: '1.25rem'}}>
            <span style={{fontSize: '22px'}}>📄</span> Általános Szerződési Feltételek
          </div>
          <h1 style={{fontSize: '32px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>NetOkos ÁSZF</h1>
          <p style={{fontSize: '14px', color: '#888', fontWeight: '700', margin: 0}}>Hatályos: 2026. augusztus 22-től</p>
        </div>


        <div style={{background: 'white', borderRadius: '24px', padding: '2.5rem', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '2px solid #f0f0f0'}}>

          <h2>1. A szolgáltatás bemutatása</h2>
          <p>
            A NetOkos (<strong>netokos.hu</strong>) egy ingyenes, magyar nyelvű, oktatási célú online platform, amely 6–14 éves gyermekeknek szóló, interaktív kiberbiztonsági és digitális tudatossági leckéket kínál. A szolgáltatást Kovács Magdolna magánszemély üzemelteti, nonprofit, hobbiprojekt jelleggel — <strong>nem áll mögötte gazdasági társaság</strong>.
          </p>

          <h2>2. A szolgáltatás igénybevétele</h2>
          <ul>
            <li>A regisztráció és a szolgáltatás használata <strong>teljesen ingyenes</strong>.</li>
            <li>A regisztrációt kizárólag <strong>18. életévét betöltött szülő vagy törvényes képviselő</strong> végezheti el, a gyermek nevében.</li>
            <li>A regisztrációval a szülő kijelenti, hogy elmúlt 18 éves, jogosult a gyermek nevében eljárni, és hozzájárul gyermeke 3. pontban részletezett adatainak kezeléséhez (lásd az Adatkezelési tájékoztatót). Ezt a regisztrációs űrlapon külön jelölőnégyzetekkel is megerősíti.</li>
            <li>Egy fiókhoz több gyermekprofil is tartozhat.</li>
          </ul>

          <h2>3. Adatkezelés</h2>
          <p>
            A szolgáltatás igénybevétele során kezelt személyes adatokról, azok kezelésének céljáról és a felhasználót megillető jogokról a külön elérhető <strong>Adatkezelési tájékoztató</strong> ad részletes tájékoztatást, amely a jelen ÁSZF elválaszthatatlan részét képezi.
          </p>

          <h2>4. A szolgáltatás elérhetősége és tartalma</h2>
          <ul>
            <li>A szolgáltató törekszik arra, hogy a NetOkos folyamatosan, megszakítás nélkül elérhető legyen, de ezt <strong>nem garantálja</strong>. A szolgáltatás időszakos karbantartás, technikai hiba, vagy a mögöttes szolgáltatók (pl. Google Firebase) leállása miatt átmenetileg elérhetetlenné válhat.</li>
            <li>A szolgáltató fenntartja a jogot, hogy a szolgáltatás tartalmát, funkcióit bármikor módosítsa, bővítse, vagy — akár előzetes értesítés nélkül — a szolgáltatást részben vagy egészben megszüntesse.</li>
            <li>A NetOkos tartalma <strong>oktatási célú kiegészítő anyag</strong>, és <strong>nem helyettesíti a szülői felügyeletet vagy a formális oktatást</strong> a digitális biztonság témakörében.</li>
          </ul>

          <h2>5. Felelősségkorlátozás</h2>
          <ul>
            <li>A szolgáltatást <strong>"ahogy van"</strong> alapon nyújtjuk, mindenféle kifejezett vagy hallgatólagos garancia nélkül a folyamatos, hibamentes működésre vonatkozóan.</li>
            <li>A szolgáltató a tőle elvárható gondossággal jár el a tartalom pontosságának és korosztályi megfelelőségének biztosítása érdekében, de nem vállal felelősséget olyan közvetett vagy következményi károkért, amelyek a szolgáltatás használatából, esetleges hibájából vagy elérhetetlenségéből erednek.</li>
            <li>A szolgáltató nem felelős a felhasználó (szülő) által megadott adatok pontosságáért.</li>
          </ul>

          <h2>6. Felhasználói magatartás</h2>
          <p>A felhasználó (szülő/gyermek) vállalja, hogy:</p>
          <ul>
            <li>A szolgáltatást csak a rendeltetésének megfelelően, jóhiszeműen használja</li>
            <li>Nem kísérli meg a szolgáltatás informatikai rendszerének jogosulatlan elérését, megzavarását</li>
            <li>A regisztráció során valós adatokat ad meg</li>
          </ul>
          <p>Ezen kötelezettségek megszegése esetén a szolgáltató jogosult a felhasználó fiókját előzetes értesítés nélkül felfüggeszteni vagy törölni.</p>

          <h2>7. Szellemi tulajdon</h2>
          <p>
            A NetOkos platformon található valamennyi tartalom (szövegek, leckék, grafikák, karakterek, logó) szerzői jogi védelem alatt áll, és a szolgáltatót illeti meg, eltérő jelölés hiányában. A tartalmak a szolgáltató előzetes írásbeli engedélye nélkül nem másolhatók, nem terjeszthetők és nem használhatók fel kereskedelmi célra.
          </p>

          <h2>8. A feltételek módosítása</h2>
          <p>
            A szolgáltató fenntartja a jogot a jelen ÁSZF egyoldalú módosítására. A módosításokról a felhasználókat a weboldalon keresztül tájékoztatjuk. A módosítás hatálybalépését követő további használat a módosított feltételek elfogadását jelenti.
          </p>

          <h2>9. Irányadó jog és kapcsolat</h2>
          <p>
            A jelen ÁSZF-re a magyar jog az irányadó. Bármilyen kérdés, észrevétel vagy panasz esetén: <a href="mailto:info.netokos@gmail.com" style={{color: '#9c27b0', fontWeight: 700}}>info.netokos@gmail.com</a>
          </p>

        </div>

        <div style={{textAlign: 'center', marginTop: '2rem'}}>
          <a href="/" style={{color: '#9c27b0', fontWeight: '800', fontSize: '15px', textDecoration: 'none'}}>← Vissza a főoldalra</a>
        </div>

      </div>
    </div>
  );
}

export default Aszf;